import useStore from "../../store"
import { useState, useEffect } from "react"
import ReusableDrawer from "../common/ReusableDrawer"
import { Button } from "@chakra-ui/react"
import { FaChevronDown } from "react-icons/fa"
import { CheckboxCard } from "@chakra-ui/react"
import { colors } from "../../utilities/colors"

export default function BranchSelect() {
  const { branches, fetchBranches, selectedBranch, setSelectedBranch, user } = useStore()
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    fetchBranches()
    if (selectedBranch.length === 0) {
      setSelectedBranch([String(user.portalBranchId)])
    }
  }, [user])

  useEffect(() => {
    if (branches?.length > 0 && !branches.some((branch) => branch.id === selectedBranch[0])) {
      setSelectedBranch([branches.find((branch) => branch.attributes.code === 'okc').id])
    }
  }, [selectedBranch, branches, user])

  const handleBranchClick = (branchId) => {
    setSelectedBranch([branchId])
    setIsOpen(false)
  }

  return (
    <>
      <Button onClick={() => setIsOpen(true)}>
        {branches?.length > 0 && branches.find((branch) => branch.id === selectedBranch[0])?.attributes.code.toUpperCase()}
        <FaChevronDown className="text-xs" />
      </Button>
      <ReusableDrawer
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        title="Branch Select"
        placement="bottom"
        bodyStyle="flex justify-center gap-4"
      >
        <div className="grid grid-cols-2 lg:grid-cols-3 md:w-2/3 w-full gap-2">
          {branches?.map((branch) => (
            <CheckboxCard.Root
              key={branch.id}
              borderWidth={2}
              borderColor={colors.grey700}
              borderRadius="md"
              _hover={{ cursor: "pointer" }}
              onClick={() => handleBranchClick(branch.id)}
              checked={selectedBranch.includes(branch.id)}
            >
              <CheckboxCard.HiddenInput />
              <CheckboxCard.Control
                justifyContent="space-between"
                alignItems="center"
              >
                <CheckboxCard.Label
                  flexDirection="column"
                  justifyContent="center"
                  alignItems="start"
                  gap={1}
                >
                  <span className="text-lg font-bold">
                    {branch.attributes.code.toUpperCase()}
                  </span>
                  <span className="text-xs text-grey-300">
                    {branch.attributes.name}
                  </span>
                </CheckboxCard.Label>
                <CheckboxCard.Indicator />
              </CheckboxCard.Control>
            </CheckboxCard.Root>
          ))}
        </div>
      </ReusableDrawer>
    </>
  )
}